import React, { Component, createRef, RefObject } from "react";

import { State } from "../types";

type Props = Readonly<{
  activeDataPoint: State["activeValue"];
  className?: string;
  selector: string | null;
}>;

export class ScrollToElement extends Component<Props> {
  private scrollRef: RefObject<HTMLDivElement>;
  public constructor(props: Props) {
    super(props);
    this.scrollRef = createRef();
  }
  public componentDidMount() {
    this.scrollToElement();
  }
  public componentDidUpdate(prevProps: Props) {
    if (prevProps.activeDataPoint !== this.props.activeDataPoint) {
      this.scrollToElement();
    }
  }
  public render() {
    return (
      <div className={this.props.className || ""} ref={this.scrollRef}>
        {this.props.children}
      </div>
    );
  }
  private scrollToElement() {
    if (this.props.selector === null) {
      return;
    }
    const { current } = this.scrollRef;
    if (!current) {
      return;
    }
    const block: HTMLElement | null = document.getElementById(this.props.selector);
    if (block) {
      current.style.scrollBehavior = "smooth";
      let offsetTop = block.offsetTop;
      let parent: HTMLElement = block.offsetParent as HTMLElement;
      while (!!parent && parent !== this.scrollRef.current) {
        offsetTop += parent.offsetTop;
        parent = parent.offsetParent as HTMLElement;
      }
      const { clientHeight } = block;
      // if the element is larger than the view port, we scroll to the top of the element
      if (clientHeight > current.clientHeight) {
        current.scrollTop = offsetTop;
        return;
      }
      // center the element in the scroll view
      const offsetY = Math.floor(offsetTop - (current.clientHeight - clientHeight) / 2);
      current.scrollTop = Math.max(0, Math.min(current.scrollHeight, offsetY));
    }
  }
}
